import React from "react";
import "./Services.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const servicesData = [
  {
    key: "diamond",
    title: "services.packages.diamond.title",
    description: "services.packages.diamond.description",
    image: "diamond.png",
  },
  {
    key: "gold",
    title: "services.packages.gold.title",
    description: "services.packages.gold.description",
    image: "gold2.jpg",
  },
  {
    key: "silver",
    title: "services.packages.silver.title",
    description: "services.packages.silver.description",
    image: "silver3.jpg",
  },
  {
    key: "pearl",
    title: "services.packages.pearl.title",
    description: "services.packages.pearl.description",
    image: "pearl5.png",
  },
];

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="wrapper">
      <section
        className="services-hero"
        style={{ backgroundImage: 'url("/Images/hero.jpg")' }}
      >
        <h1 className="services-hero__title">{t("services.heroTitle")}</h1>
      </section>

      <section className="services-comparison">
        <div className="services-comparison__container">
          <h2 className="services-comparison__title">
            {t("services.comparison.title")}
          </h2>

          <table className="services-comparison__table">
            <thead>
              <tr>
                <th>{t("services.comparison.features")}</th>
                <th>{t("services.packages.diamond.short")}</th>
                <th>{t("services.packages.gold.short")}</th>
                <th>{t("services.packages.silver.short")}</th>
                <th>{t("services.packages.pearl.short")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t("services.comparison.finalVideoLength")}</td>
                <td>6-8 {t("services.comparison.minutes")}</td>
                <td>5 {t("services.comparison.minutes")}</td>
                <td>5 {t("services.comparison.minutes")}</td>
                <td>3 {t("services.comparison.minutes")}</td>
              </tr>
              <tr>
                <td>{t("services.comparison.preparations")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__red">✖</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__red">✖</td>
              </tr>
              <tr>
                <td>{t("services.comparison.fullCeremony")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
              </tr>
              <tr>
                <td>{t("services.comparison.reception")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__red">✖</td>
                <td className="services-comparison__red">✖</td>
              </tr>
              <tr>
                <td>{t("services.comparison.unedited")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
              </tr>
              <tr>
                <td>{t("services.comparison.firstDance")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__red">✖</td>
                <td className="services-comparison__red">✖</td>
              </tr>
              <tr>
                <td>{t("services.comparison.trailer")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
              </tr>
              <tr>
                <td>{t("services.comparison.vows")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
              </tr>
              <tr>
                <td>{t("services.comparison.editDelivery")}</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
                <td className="services-comparison__green">✔</td>
              </tr>
              <tr>
                <td>{t("services.comparison.price")}</td>
               <td>{t("services.comparison.prices.diamond")}</td>
                <td>{t("services.comparison.prices.gold")}</td>
                <td>{t("services.comparison.prices.silver")}</td>
                <td>{t("services.comparison.prices.pearl")}</td>
              </tr>
            </tbody>
          </table>

          <h2 className="services-comparison__title">
            {t("services.comparison.addonsTitle")}
          </h2>

          <table className="services-comparison__table">
            <tbody>
              <tr>
                <td>{t("services.comparison.halfDay")}</td>
                <td>{t("services.comparison.halfDayDesc")}</td>
                <td>{t("services.comparison.prices.halfDay")}</td>
              </tr>
              <tr>
                <td>{t("services.comparison.fullDay")}</td>
                <td>{t("services.comparison.fullDayDesc")}</td>
                <td>{t("services.comparison.prices.fullDay")}</td>
              </tr>
              <tr>
                <td>{t("services.comparison.loveStory")}</td>
                <td>{t("services.comparison.loveStoryDesc")}</td>
                <td>{t("services.comparison.prices.loveStory")}</td>
              </tr>
              <tr>
                <td>{t("services.comparison.fomo")}</td>
                <td>{t("services.comparison.fomoDesc")}</td>
                <td>{t("services.comparison.prices.fomo")}</td>
              </tr>
            </tbody>
          </table>

          <Link to="/contact">
            <button className="services-comparison__button">
              {t("services.book")}
            </button>
          </Link>
        </div>
      </section>

      <section className="service-section">
        <div className="service-section__container">
          <span className="service-section__dot"></span>
          {servicesData.map((service, index) => (
            <div className="service-section__card" key={index}>
              <div className="service-section__content">
                <h2 className="service-section__title">{t(service.title)}</h2>
                <p className="service-section__description">
                  {t(service.description)}
                </p>
              </div>
              <div className="service-section__image-container">
                <img
                  className="service-section__image"
                  src={`/Images/${service.image}`}
                  alt={t(service.title)}
                />
              </div>
            </div>
          ))}
          <span className="service-section__dot"></span>
        </div>
      </section>
    </div>
  );
};

export default Services;
